<template
  ><article
    class="scene-card"
    :data-sorting="$store.state.configinfo.objectMoveState ? 'true' : null"
    :class="{ configuring: viewType === 'configScene', selected: viewType === 'configScene' && OneScene.followState === 1 }"
    tabindex="0"
    role="button"
    :aria-pressed="viewType === 'configScene' ? OneScene.followState === 1 : undefined"
    :aria-label="OneScene.sceneName"
    @keydown.enter.prevent="sceneBtnClickHandle"
    @click="sceneBtnClickHandle"
    @contextmenu.prevent="sceneRightClickBtnHandle"
  >
    <span class="scene-icon"><img :src="OneScene.iconUrl" alt=""/></span>
    <div class="scene-copy">
      <ellipsis-tooltip class="scene-name" :text="OneScene.sceneName" />
      <ellipsis-tooltip class="scene-region" :text="OneScene.regionName" />
    </div>
    <span v-if="viewType === 'configScene' && OneScene.followState === 1" class="scene-selection">{{ OneScene.followOrder }}</span>
    <span v-if="viewType === 'configScene'" class="card-selection" :class="{ checked: OneScene.followState === 1 }" aria-hidden="true"></span>
  </article></template
>
<script>
import EllipsisTooltip from 'components/common/ellipsis-tooltip/ellipsis-tooltip'
import { judgeActivePage, publicFadeInOut, jieMianStateJudge } from 'common/tool'
import { requestSceneRule } from '../../../../network/request'
export default {
  components: { EllipsisTooltip },
  data() {
    return {
      followOrder: ''
    }
  },
  props: {
    disabled: { type: Boolean, default: false },
    OneScene: Object,
    viewType: {
      type: String,
      default: ''
    }
  },
  methods: {
    sceneBtnClickHandle() {
      if (this.disabled) return
      ////场景被点击了
      // console.log(this.OneScene.sceneName)
      if (!jieMianStateJudge()) return ///界面管理状态判断

      if (this.viewType === '') {
        this.$showControlToast('scene', this.OneScene)
      } else if (this.viewType === 'configScene') {
        if (this.OneScene.followState === 1) {
          ///取消收藏
          this.$emit('followOrderCompuder', this.OneScene.followOrder)
          this.OneScene.followState = 0
          this.OneScene.followOrder = 0
        } else {
          ///添加收藏
          this.$emit('followOrderCompuInc', this.OneScene)

          this.OneScene.followState = 1
        }
      }
    },
    sceneRightClickBtnHandle() {
      if (!jieMianStateJudge()) return ///界面管理状态判断

      // 主账号判断  0主账号
      console.log('当前是子账号不支持')
      if (sessionStorage.getItem('userType') != '0') return
      console.log('场景对象的右击事件')
      this.$showTipsToast(14, this.OneScene)
    }
  }
}
</script>
<style scoped>
.scene-card {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  width: 100%;
  height: 64px;
  box-sizing: border-box;
  padding: 10px 12px;
  position: relative;
  border: 0;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.96);
  color: #202124;
  cursor: pointer;
}
.scene-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 42px;
  height: 42px;
  border-radius: 13px;
  background: rgba(78, 110, 242, 0.08);
}
.scene-icon img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}
.scene-copy {
  flex: 1;
  min-width: 0;
}
.scene-copy .scene-name,
.scene-copy .scene-region {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.scene-copy .scene-name {
  font-size: 16px;
  font-weight:400;
}
.scene-copy .scene-region {
  font-size: 12px;
  color: #8a8f98;
  margin-top: 3px;
}
.scene-card.configuring .scene-copy { padding-right: 22px; }
.scene-selection {
  position: absolute; top: 10px; right: 12px; font-size: 16px; font-weight: 600;
  color: var(--primary-color);
}
.scene-card.selected {
  background: rgba(218, 229, 255, 0.99);
}
</style>
